import { useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { ComponentVersionsInherit, Drawer, styled } from 'opensolar-ui'
import PropTypes from 'prop-types'
import { setSidebarVisibility } from 'ra-core'
import { Children, cloneElement } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const CONTROL_NAV_WIDTH = 240

const hideScrollbarStyles = {
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}

const ControlDrawer = styled(Drawer, { name: 'ControlSidebarDrawer' })(({ theme }) => ({
  minHeight: 'unset',
  overflowY: 'auto',
  ...hideScrollbarStyles,
  '& .MuiDrawer-paper, & .OSUI-Paper-root': {
    height: 'fit-content',
    position: 'relative',
    overflowX: 'hidden',
    ...hideScrollbarStyles,
    width: CONTROL_NAV_WIDTH,
    backgroundColor: 'transparent',
    marginBottom: 0,
    borderRight: 'none',
    zIndex: 'inherit',
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      height: '100vh',
      position: 'inherit',
      backgroundColor: theme.palette.background.default,
    },
  },
}))

const OpenContent = styled('div', { name: 'ControlSidebarOpenContent' })(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: CONTROL_NAV_WIDTH,
  minWidth: CONTROL_NAV_WIDTH,
  height: '100%',
  minHeight: 0,
  backgroundColor: theme.palette.background.paper,
}))

const MenuContent = styled('div', { name: 'ControlSidebarMenuContent' })({
  flex: 1,
  minHeight: 0,
})

const ControlSidebar = ({ children, ...rest }) => {
  const dispatch = useDispatch()
  const theme = useTheme()
  const mobileMediaQuery = theme.breakpoints.down('sm')
  const isMobile = useMediaQuery(mobileMediaQuery, {
    defaultMatches:
      typeof window !== 'undefined' && window.matchMedia(mobileMediaQuery.replace(/^@media\s*/, '')).matches,
  })
  const sidebarOpen = useSelector((state) => state.admin.ui.sidebarOpen)

  const handleClose = () => dispatch(setSidebarVisibility(false))

  if (isMobile) {
    return (
      <ComponentVersionsInherit versions={{ drawer: 1 }}>
        <ControlDrawer variant="temporary" open={sidebarOpen} onClose={handleClose} {...rest}>
          {cloneElement(Children.only(children), {
            onMenuClick: handleClose,
          })}
        </ControlDrawer>
      </ComponentVersionsInherit>
    )
  }

  return (
    <ComponentVersionsInherit versions={{ drawer: 1 }}>
      <ControlDrawer variant="permanent" open {...rest}>
        <OpenContent>
          <MenuContent>{children}</MenuContent>
        </OpenContent>
      </ControlDrawer>
    </ComponentVersionsInherit>
  )
}

ControlSidebar.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ControlSidebar
